// extracted by mini-css-extract-plugin
export default {"thank-you-for-helping-modal":"oeevs","high-five":"IDqB3","title":"psimz","subtitle":"HwRmi","button-container":"wLfKZ"};